document.addEventListener("DOMContentLoaded", function () {
  const giftWrapHandle = "gaveindpakning";

  function showGiftDatePopup() {
    if (document.getElementById("giftdate-popup")) return;

    const popupHTML = `
      <div id="giftdate-popup" style="position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:9999; display:flex; justify-content:center; align-items:center;">
        <div style="background:white; padding:2rem; border-radius:10px; max-width:400px; text-align:center; position:relative;">
          <h3 style="margin-bottom:1rem;">🎁 Hvornår skal gaven gives?</h3>
          <p style="margin-bottom:1rem;">Så tilpasser vi din returret.</p>
          <input type="date" id="giftdate-input" style="margin-bottom:1rem; padding:6px; width:100%;" required />
          <br>
          <button id="giftdate-save" class="btn btn--primary" style="margin-right: 10px;">Gem dato</button>
          <button id="giftdate-cancel" class="btn btn--secondary">Spring over</button>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML("beforeend", popupHTML);

    document.getElementById("giftdate-save").addEventListener("click", () => {
      const date = document.getElementById("giftdate-input").value;
      if (!date) return alert("Vælg venligst en dato.");
      const noteText = `Gaven gives den: ${date}`;

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ note: noteText }),
      })
        .then(() => {
          document.getElementById("giftdate-popup").remove();
          showConfirmationBadge("🎉 Gavedato gemt!");
          renderGiftDateInCart(noteText);
        })
        .catch(err => console.error("Fejl ved opdatering af note:", err));
    });

    document.getElementById("giftdate-cancel").addEventListener("click", () => {
      document.getElementById("giftdate-popup").remove();
    });
  }

  function showConfirmationBadge(message) {
    const badge = document.createElement("div");
    badge.textContent = message;
    Object.assign(badge.style, {
      position: "fixed",
      bottom: "20px",
      right: "20px",
      background: "#222",
      color: "#fff",
      padding: "10px 15px",
      borderRadius: "8px",
      fontSize: "14px",
      zIndex: 10000,
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    });
    document.body.appendChild(badge);
    setTimeout(() => badge.remove(), 4000);
  }

  function renderGiftDateInCart(noteText) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const dateMatch = cart.note?.match(/Gaven gives den: ([0-9\-]+)/);
        const currentDate = dateMatch ? dateMatch[1] : '';

        const nameLinks = document.querySelectorAll('.cart__item-name');

        nameLinks.forEach(link => {
          if (link.href.includes('/products/gaveindpakning')) {
            const container = link.closest('.cart__item');
            const infoSection = container?.querySelector('.cart__item-info') || container;
            if (!infoSection || infoSection.querySelector('.giftdate-editor')) return;

            const wrapper = document.createElement('div');
            wrapper.className = 'giftdate-editor';
            wrapper.style.marginTop = '0.75rem';
            wrapper.style.width = '100%';
            wrapper.style.boxSizing = 'border-box';

            wrapper.innerHTML = `
              <div style="display: block; width: 100%;">
                <label for="giftdate-inline" style="font-size: 0.85rem; display: block; margin-bottom: 0.25rem;">
                  🎁 Gavedato:
                </label>
                <div style="display: block; width: 100%;">
                  <input type="date" value="${currentDate}" id="giftdate-inline"
                    style="width: 100%; padding: 6px; box-sizing: border-box; margin-bottom: 0.5rem;" />
                  <button class="btn btn--small"
                    style="width: 100%; padding: 6px 12px; box-sizing: border-box;" id="giftdate-inline-save">
                    Gem dato
                  </button>
                </div>
              </div>
            `;

            infoSection.appendChild(wrapper);

            // 👇 Tilføj preventDefault her
            wrapper.querySelector('#giftdate-inline-save').addEventListener('click', (e) => {
              e.preventDefault();
              const newDate = wrapper.querySelector('#giftdate-inline').value;
              if (!newDate) return alert('Vælg en dato');

              fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  note: `Gaven gives den: ${newDate}`,
                }),
              })
                .then(() => {
                 const saveButton = wrapper.querySelector('#giftdate-inline-save');
saveButton.textContent = "✅ Gemt";
saveButton.disabled = true;

setTimeout(() => {
  saveButton.textContent = "Gem dato";
  saveButton.disabled = false;
}, 2000);

                })
                .catch(err => console.error("Fejl ved opdatering af dato:", err));
            });
          }
        });
      });
  }

  function checkCartAndMaybeShowPopup() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const hasGiftWrap = cart.items.some(item => item.handle === giftWrapHandle);
        const noteAlreadySet = cart.note && cart.note.includes('Gaven gives den:');

        if (hasGiftWrap && !noteAlreadySet) {
          showGiftDatePopup();
        } else if (noteAlreadySet) {
          renderGiftDateInCart(cart.note);
        }
      });
  }

  checkCartAndMaybeShowPopup();

  document.body.addEventListener('click', function (e) {
    const clickedEl = e.target;
    const addButton = clickedEl.closest('.quick-add-btn, [name="add"], .product-form__submit');
    if (addButton) {
      setTimeout(checkCartAndMaybeShowPopup, 2000);
    }
  });

  function waitForCartDrawerAndObserve(retries = 10) {
    const cartDrawer = document.querySelector('[id*="CartDrawer"], .cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(checkCartAndMaybeShowPopup);
      observer.observe(cartDrawer, { childList: true, subtree: true });
      console.log("[byMalumade] Cart drawer observer startet.");
    } else if (retries > 0) {
      setTimeout(() => waitForCartDrawerAndObserve(retries - 1), 500);
    } else {
      console.warn("[byMalumade] Cart drawer ikke fundet – observer blev ikke startet.");
    }
  }

  waitForCartDrawerAndObserve();
});
